import { ColorEnum } from '@/constants/color'
import CancelButton from '@/features/common/buttons/CancelButton'
import ConfirmButton from '@/features/common/buttons/ConfirmButton'
import { EditAutomaticContainersModalActions } from '@/features/pos/components/Cart/parts/EditAutomaticContainersModal/types'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

type ActionButtonsProps = Pick<EditAutomaticContainersModalActions, 'onCancel' | 'onConfirm'>

const ActionButtons: FC<ActionButtonsProps> = ({ onCancel, onConfirm }) => (
    <View style={styles.container}>
        <CancelButton onPress={onCancel} />
        <ConfirmButton onConfirm={onConfirm} />
    </View>
)

const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        right: 0,
        bottom: 0,
        left: 0,
        flexDirection: 'row',
        backgroundColor: ColorEnum.VIOLET_100,
        borderRadius: 16,
        padding: 16,
        gap: 16,
    },
})

export default ActionButtons
